import {
  ITransferMissingTraysData,
  ITransferMissingTraysResponse,
} from '../../../types';

/**
 * This function formats the response for missing trays during transfer.
 * It extracts the trays and total count from the response data,
 * and formats each tray item to include a missing tray label.
 */
export function formatMissingTraysResponse(
  response: ITransferMissingTraysResponse
): ITransferMissingTraysData {
  const { trays, total } = response.data || {};

  return {
    total,
    trays: trays.map((trayItem) => {
      const { trayNumber, inventoryTransferInfo, inventoryTransferId } =
        trayItem;

      return {
        ...trayItem,
        inventoryTransferInfo: { ...inventoryTransferInfo },
        missingTrayLabel: `${trayNumber} - ${inventoryTransferId || 'N/A'}`,
      };
    }),
  };
}
